export const defaultErrorMessage = 'Something went wrong. Please try again later.';

export const authorizationError = 'authorizationError';
